import styled, { CSSObject } from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const mobileStyles: CSSObject = {
  marginBottom: '13px'
};

const desktopStyles: CSSObject = {
  marginBottom: 0
};

const StyledInfoDiv = styled.div({
  display: 'inline-flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  [media('xs')]: mobileStyles,
  [media('lg')]: desktopStyles
});

export default StyledInfoDiv;
